import React from 'react';
import { usePricing } from '../contexts/PricingContext';

export const ExpirySelector = () => {
  const { 
    selectedExpiry, 
    availableExpiries, 
    updateStrikesForExpiry,
    lastStrikeUpdate 
  } = usePricing();

  console.log('🕐 ExpirySelector RENDER:', {
    selectedExpiry,
    availableExpiries: availableExpiries.length,
    lastUpdate: lastStrikeUpdate
  });

  const handleExpiryChange = (newExpiry) => {
    console.log(`🔄 EXPIRY SELECTED: ${selectedExpiry} → ${newExpiry}`);
    updateStrikesForExpiry(newExpiry);
  };

  if (!availableExpiries || availableExpiries.length === 0) {
    return (
      <div className="bg-atticus-navy-900 rounded-xl p-4">
        <div className="text-gray-400 text-center">Loading expiries...</div>
      </div>
    );
  }

  return (
    <div className="bg-atticus-navy-900 rounded-xl p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white text-lg font-medium">Expiry</h3>
        <div className="text-xs text-gray-500">
          {lastStrikeUpdate && (
            `Updated: ${new Date(lastStrikeUpdate).toLocaleTimeString()}`
          )}
        </div>
      </div>
      
      <div className="flex justify-between w-full gap-1">
        {availableExpiries.map((expiry) => (
          <button
            key={expiry}
            onClick={() => handleExpiryChange(expiry)}
            className={`flex-1 py-3 px-2 rounded-lg font-medium text-sm transition-all duration-200 ${
              selectedExpiry === expiry
                ? 'bg-yellow-300 text-black font-bold shadow-lg transform scale-105'
                : 'bg-gray-800 text-white hover:bg-gray-700 hover:text-gray-200'
            }`}
          >
            {expiry}
          </button>
        ))}
      </div>
      
      {/* Debug info */}
      <div className="mt-3 text-xs text-gray-500 text-center">
        Selected: {selectedExpiry} • Available: {availableExpiries.join(', ')}
      </div>
    </div>
  );
};
